import { ImagilityBaseResponse, SuperTask } from 'app-models';
import { mergeMap, takeUntil } from 'rxjs/operators';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { LookupService } from 'src/app/services/lookup-data.service';
import { ToastrService } from 'ngx-toastr';
import { TemplateService } from 'src/app/services/template.service';
import * as moment from 'moment';
import { forkJoin, Subject } from 'rxjs';
import { PetitionUpdateInitService } from './../petition-update-init.service';
import { environment } from 'environment-configurations';
import { PetitionBuilderService } from 'src/app/services/petition-builder.service';
import { Store } from '@ngrx/store';
import { getSuperTask } from 'visa-store';

@Component({
  selector: 'app-petition-update-init',
  templateUrl: './petition-update-init.component.html',
  styleUrls: ['./petition-update-init.component.scss']
})
export class PetitionUpdateInitComponent implements OnInit {
  modify: boolean[];
  step1: boolean = false;
  step2: boolean = false;
  // displayedColumns: string[] = ['feetype', 'amount', 'action'];
  displayedColumns: string[] = ['feetype', 'amount'];
  feeDataSource: MatTableDataSource<any>;
  templates: { name: string, id: number, isDefault: boolean }[] = [];
  deftaultTemplate: { name: string, id: number, isDefault: boolean };
  coverLetterTemplateId: number;
  immigrantType;
  receiptNumber;
  petitionId;
  serviceCenterName: string;
  attrFirmName: string;
  preparerName: string;
  attorneys: any[];
  attorneyUsers = [];
  questionList: any[];
  companyId;
  taskUpdate = {
    attrSelected: '',
    preparerAttorneyId: '0'
  };
  task: any;
  errorMessage;
  userType;
  selectedCompanyId;
  showFee: boolean;
  newPetitionfee: number;
  premiumFee: number;
  petitionDocs: any;
  isReceiptPresent: boolean = false;
  pdfAlreadyGenerated: boolean = false;
  pdfGeneratedDate: string;
  printPDFPath: string;
  allPdfDocs = [];
  updatedAttorney: any;
  isSubmitted: boolean = false;
  observableSubscription$ = new Subject();
  superTaskDetails: SuperTask;
  getSuperTaskType: any;
  enableViewDraftButton = false;
  isAttorneyChange = false;
  isServiceCenterChange = false;

  constructor(
    public dialogRef: MatDialogRef<PetitionUpdateInitComponent>,
    private toastr: ToastrService,
    private lookupService: LookupService,
    private pbService: PetitionBuilderService,
    private templateService: TemplateService,
    private petitionUpdateInitService: PetitionUpdateInitService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<any>
  ) {
    this.modify = this.data.modify;
    this.task = this.data.task;
    //this.petitionId = this.data.petitionId || null;
    this.receiptNumber = this.data.receiptNumber ? this.data.receiptNumber : 'Nil';
    this.task.companyId = this.data.companyId || null;
    this.selectedCompanyId = this.data.selectedCompanyId || null;
    this.userType = this.data.userType || null;
    this.immigrantType = this.data.immigrantType || null;
    this.questionList = this.data.questionList || [];
    this.step2 = false;
    this.step1 = true;
    this.showFee = true;
    this.serviceCenterName = this.data.serviceCenterName;
    this.updatedAttorney = this.data.updatedAttorney;
    this.pdfGeneratedDate = '';
  }

  ngOnInit(): void {
    this.getAttorney();
    // this.getCoverLetterTemplates();
    this.getFeesStructure();
    this.store.select(getSuperTask).pipe(takeUntil(this.observableSubscription$)).subscribe((data: SuperTask) => {
      this.superTaskDetails = data;
    });
  }

  getAttorney() {
    if (this.updatedAttorney) {
      this.lookupService.getActiveAttorneyCompanyList(sessionStorage.getItem('companyId'))
        .pipe(
          mergeMap((response: any[]) => {
            this.attorneys = response;
            this.taskUpdate.attrSelected = this.updatedAttorney.newAttCompanyId;
            return this.lookupService.getUsersOfCompany(this.taskUpdate.attrSelected);
          })
        ).subscribe((data: Array<any>) => {
          this.attorneyUsers = data;
          this.taskUpdate.preparerAttorneyId = this.updatedAttorney.newAttId;
          this.attorneyUserSelected();
        });
    } else {
      this.lookupService.getActiveAttorneyCompanyList(sessionStorage.getItem('companyId')).subscribe((data: Array<any>) => {
        this.attorneys = data;
      });
    }
  }

  onCvrLtrTmpateChange(event) {
    this.coverLetterTemplateId = parseInt(event.value);
  }

  attorneySelected() {
    if (this.taskUpdate.attrSelected && this.taskUpdate.attrSelected !== '') {
      this.lookupService.getUsersOfCompany(this.taskUpdate.attrSelected).subscribe((data: Array<any>) => {
        this.attorneyUsers = data;
        this.taskUpdate.preparerAttorneyId = '0';
      });
    }
    else {
      this.attorneyUsers = [];
      this.taskUpdate.preparerAttorneyId = '0';
    }
  }

  attorneyUserSelected() {
    this.attrFirmName = this.attorneys.find(x => x.attorneyId === Number(this.taskUpdate.attrSelected)).attorneyName;
    const selectedAttr = this.attorneyUsers.find(x => x.id === Number(this.taskUpdate.preparerAttorneyId));
    this.preparerName = selectedAttr.firstName + ' ' + selectedAttr.middleName + ' ' + selectedAttr.lastName;
  }


  nextStep() {
    this.isAttorneyChange = this.modify && this.modify[0] && this.modify[0] === true ? true : false;
    this.isServiceCenterChange = this.modify && this.modify[1] && this.modify[1] === true ? true : false;
    this.templates = [];
    this.getCoverLetterTemplateList();
    this.petitionUpdateInitService.getAllPBDocs(this.task.petitionId, this.isAttorneyChange, this.isServiceCenterChange)
      .subscribe(response => {
        if (response) {
          this.checkAllPdfDocs(response);
          this.step1 = false;
          this.step2 = true;
        }
      });
  }

  backToStepOne() {
    this.step1 = true;
    this.step2 = false;
  }

  checkAllPdfDocs(response) {
    if (response.modifiedDate && response.updatePetitionFileLocation) {
      this.pdfGeneratedDate = response.modifiedDate;
      this.printPDFPath = `${environment.docs}${response.updatePetitionFileLocation.replace('/var/imagility/uploads/', '')}`;
      this.pdfAlreadyGenerated = true;
    } else {
      this.pdfAlreadyGenerated = false;
    }
    this.allPdfDocs = response.documentListDto.filter(x =>
      (this.modify.length && this.modify[0] && x.fileCategory.code === 'G28') ||
      (this.modify.length && this.modify[1] && x.fileCategory.code === 'I907') ||
      x.fileCategory.code === 'COVLTR' || x.fileCategory.code === 'RECNOTC');
    const receipt = this.allPdfDocs.find(x => x.fileCategory.code === 'RECNOTC');
    this.isReceiptPresent = receipt ? receipt.isPresent : false;
  }

  viewPDF() {
    window.open(this.printPDFPath);
  }

  getCoverLetterTemplateList() {
    const payload = {
      "immClassificationType": this.superTaskDetails.immigrationClassification ? this.superTaskDetails.immigrationClassification.code : null,
      "immCategoryType": this.superTaskDetails.immigrationCategory ? this.superTaskDetails.immigrationCategory.code : null,
      "petitionType": this.superTaskDetails ? this.superTaskDetails?.petitionType?.code : null,
      "taskTypeRefId": this.getSuperTaskType ? this.getSuperTaskType?.taskTypeCode : null,
      "superTaskTypeId": this.getSuperTaskType ? this.getSuperTaskType?.superTaskTypeCode : null,
      "visaType": this.data?.task?.taskTypeDetails && this.data.task?.taskTypeDetails?.visaType ? this.data.task.taskTypeDetails.visaType : null,
      "isDefault": null,
      "pageNumber": 0,
      "pageSize": 0,
      "pageIndex": 0,
      "recordsPerPage": 25,
      "searchText": "",
      "documentType": 'COVLTR',
    }

    this.petitionUpdateInitService.getCoverLetterTemplateList(this.data.task.companyId, payload)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: ImagilityBaseResponse) => {
        response.data.documentTemplate.forEach(element => {
          this.deftaultTemplate = {
            name: element.templateName,
            id: element.id,
            isDefault: element.isDefault === 'true' ? true : false
          };
          if (element.isDefault === 'true') {
            this.coverLetterTemplateId = this.deftaultTemplate.id;
          }
          this.templates.push({ name: element.templateName, id: element.id, isDefault: element.isDefault });
        });
      });
  }

  getFeesStructure() {
    this.pbService.getMasterFeesStructure(this.task.petitionId).subscribe(data => {
      if (data.feeType === 'Premium') {
        this.premiumFee = this.newPetitionfee = data.applicableFee || 0;
        this.feeDataSource = new MatTableDataSource([{ feetype: 'Premium Processing Fee', amount: this.premiumFee, action: 'edit' }]);
      }
    });

  }

  // save selections
  saveChanges() {
    this.isSubmitted = true;
    const docstypes = [];
    const payload = {
      "attorney": null,
      "seviceCenter": null
    }
    // cover letter preview api 
    const coverLetterPreviewPayload = {
      templateId: Number(this.coverLetterTemplateId)
    };
    docstypes.push(this.petitionUpdateInitService.getPreview(this.task.taskTypeDetails.visaType, 'PETITION', this.task.petitionId, 'COVLTR', this.task.superTaskId, this.task.id, coverLetterPreviewPayload));
    if (this.modify.length && this.modify[0]) {
      // Generate G28 Document
      docstypes.push(this.petitionUpdateInitService.generateForms(this.task.taskTypeDetails.visaType, 'PETITION', this.task.petitionId, this.task.superTaskId, this.task.id, 'G28'));
      // construct payload for attorney
      payload.attorney = {
        "eventTypeCode": 'UPDATEV',
        "newAttCompanyId": this.taskUpdate.attrSelected,
        "newAttId": this.taskUpdate.preparerAttorneyId,
        "oldAttCompanyId": String(this.task.attorneyId),
        "oldAttId": String(this.task.preparerAttorneyId),
        "taskId": this.task.id,
      };
    }
    if (this.modify.length && this.modify[1]) {
      // Generate I907 Document
      docstypes.push(this.petitionUpdateInitService.generateForms(this.task.taskTypeDetails.visaType, 'PETITION', this.task.petitionId, this.task.superTaskId, this.task.id, 'I907'));
      // construct payload for serviceCenter
      payload.seviceCenter = {
        "eventTypeCode": 'PROCTYPCHANGEEV',
        "newData": 'Premium',
        "oldData": 'Regular',
        "taskId": this.task.id,
      };
    }

    this.petitionUpdateInitService.postUpdateSeviceCenterAndAttorney(payload)
      .subscribe((response: ImagilityBaseResponse) => {
        this.toastr.success(response.message, 'Success');
        this.updatePetition(docstypes);
      });
  }


  updatePetition(docstypes) {
    forkJoin(docstypes).subscribe((responseArr: ImagilityBaseResponse[]) => {
      if (responseArr) {
        responseArr.forEach(response => {
          this.toastr.success(response.message, 'Success');
        });
        const coverLetterPayload = {
          templateId: Number(this.coverLetterTemplateId)
        };
        this.petitionUpdateInitService.generatePDF(this.task.taskTypeDetails.visaType, 'PETITION', this.task.petitionId, 'COVLTR', coverLetterPayload).subscribe((coverLetterResponse) => {
          if (coverLetterResponse && coverLetterResponse.status === 200) {
            this.toastr.success(coverLetterResponse.message, 'Success');
            // generate cover letter
            this.petitionUpdateInitService.getAllPBDocs(this.task.petitionId, this.isAttorneyChange, this.isServiceCenterChange).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
              this.petitionUpdateInitService.generateAllDocs(this.task.petitionId, response.documentListDto).pipe(takeUntil(this.observableSubscription$))
                .subscribe((response: ImagilityBaseResponse) => {
                  if (response.data.modifiedDate && response.data.fileLocation && response.data.fileName) {
                    this.pdfGeneratedDate = response.data.modifiedDate;
                    this.printPDFPath = `${environment.docs}${response.data.fileLocation.replace('/var/imagility/uploads/', '')}${response.data.fileName}`;
                    this.pdfAlreadyGenerated = true;
                    this.toastr.success(response.message, 'Success');
                  } else {
                    this.pdfAlreadyGenerated = false;
                  }
                });
            });
          }
        });
      }
    });
  };

  onDismiss(): void {
    this.dialogRef.close(false);
  }

}
